import React from 'react'
import { Badge, TakeAways, LazyLoad, SeoHelmet } from '../../common/Functions'
import Roles from './roles'
import Ecosystem from './ecosystem'

function Eo() {
  return (
   <div id="works">
    <SeoHelmet title="EO PH" description="A web app portal to manage events, posts, videos, and organization for EO PH (Entrepreneurs' Organization Philippines) administrators and downloadable mobile app for EO PH members." />
    <section className="banner eo px-0">
      <div className="max-w-screen-xl	mx-auto">
        <main className="mt-10">
          <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
            <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0 mt-10">
              <div className="content">
                <h1 className="text-left font-bold text-3xl text-white">
                  A web app portal to manage events, posts, videos, and organization for EO PH (Entrepreneurs' Organization Philippines) administrators and downloadable mobile app for EO PH members.
                </h1>
                <p className="text-white mt-10">
                  Learn how I help provide digital solutions to manage an organization.
                </p>
                <div className="roles mt-20">
                  <Badge title="Project Manager" />
                  <Badge title="UX/UI Design" />
                  <Badge title="Web & Mobile Application" />
                </div>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full sm:order-first md:order-first lg:order-last flex items-center justify-center">
              <LazyLoad className="inline h-auto w-4/5" src={require('../../common/images/home/eo.png')} alt="EO Logo" />
            </div>
          </div>
        </main>
      </div>
      </section>
      <Roles />
      <Ecosystem />
      <TakeAways content="Most of the features of this project were practiced and applied in our previous projects. In less than a year, our team was able to finish the project. It was an accomplishment for me & kudos to the team because it all happened during the pandemic when the world is in chaos. Besides, it is the first project that I handled where all meetings were through virtual or online calls." />
   </div>
  )
}

export default Eo
